'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

module.exports = _react2['default'].createClass({
  displayName: 'exports',

  propTypes: {
    page: _react.PropTypes.shape({
      data: _react.PropTypes.string
    })
  },

  render: function render() {
    var html = this.props.page.data;
    return _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: html } });
  }
});


/** WEBPACK FOOTER **
 ** ../~/gatsby/dist/isomorphic/wrappers/html.js
 **/